import request from '@/common/request'
import {commonParams, PLATFORM} from '@/api/config'
import {getToken} from '@/common/auth'

export function Login(username, password) {
  return request({
    url: './LoginByPassword',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginName: username,
      passWord: password,
      platform: PLATFORM
    })
  })
}

export function LoginByWxkey(wxkey) {
  return request({
    url: './LoginByWxKey',
    method: 'post',
    data: Object.assign({}, commonParams, {
      wxkey
    })
  })
}

export function LoginByWxCode(code) {
  return request({
    url: './LoginByWxCode',
    method: 'post',
    data: Object.assign({}, commonParams, {
      format: 'json',
      code
    })
  })
}

export function LogOut() {
  const loginKey = getToken()
  return request({
    url: './LogOut',
    method: 'post',
    data: Object.assign({}, commonParams, {
      loginKey
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js